import React, {useState} from "react";

import * as AssetsService from "../../api/AssetsService"
import cabinetStyle from "./MentorCabinet.module.css";
import PageTips from "../PageTips";
import Style from "../Style.module.css";
import myCardStyle from "./MyCards.module.css"
import EditComponent from "./EditComponent";
import DeleteComponent from "./DeleteComponent";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import DialogComponent from "../DialogComponent";
import MyCard from "./MyCard";
import CloseComponent from "./CloseComponent";
import SaveComponent from "./SaveComponent";
import {useTranslation} from "react-i18next";
import addPlus from "../../image/green_plus.png"
import MyCardsDeckEditAddOwnBackground from "./MyCardsDeckEditAddOwnBackground";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CardTextModalPreview from "../CardTextModalPreview";

export default function MyCardsDeckEdit(props) {
    const [deck, setDeck] = useState()
    const [fetched, setFetched] = useState(false)
    const [nameEdit, setNameEdit] = useState(false)
    const [styleEdit, setStyleEdit] = useState(false)
    const [availableCardStyles, setAvailableCardStyles] = useState([])
    const [deleteDeckRequested, setDeletDeckRequested] = useState(false)
    const [addBackgroundDialog, setAddBackgroundDialog] = useState(false)
    const [cardPreviewModal, setCardPreviewModal] = useState(false)
    const {t} = useTranslation('translation', {keyPrefix: 'myCardsDeckEdit'});

    const [newName, setNewName] = useState()

    function fetchDeck() {
        AssetsService.getCustomDeckById(
            props.deck_id,
            (deck) => {
                setDeck(deck)
                setNewName(deck.name)
                setFetched(true)
                setNameEdit(false)


            }, () => {
                window.alert(t('error'))
            })
    }


    useEffectOnce(() => {
        fetchDeck()
        fetchAvailableStyles()
    }, [])

    function resolveNewName(evt) {
        setNewName(evt.target.value)
    }

    function skipNameEdit() {
        setNameEdit(false)
        setNewName(deck.name)
    }

    function saveNewName() {
        AssetsService.postCustomDeckUpdate(
            deck.id,
            newName,
            null,
            () => {
                fetchDeck()
            },
            () => {
                window.alert(t('error'))
            })
    }

    function saveNewDeckId(newDeckId) {
        AssetsService.postCustomDeckUpdate(
            deck.id,
            null,
            newDeckId,
            () => {
                fetchDeck()
            },
            () => {
                window.alert(t('error'))
            })
    }

    function requestDeckDelete() {
        setDeletDeckRequested(true)
    }

    function deleteDeck() {
        AssetsService.deleteCustomDeck(
            deck.id,
            () => {
                props.setCurrentView("my_cards_menu")
            },
            () => {
                window.alert(t('error'))
            }
        )
    }

    function fetchAvailableStyles() {
        AssetsService.getAvailableCustomCardStyles(
            setAvailableCardStyles,
            () => setAvailableCardStyles([])
        )
    }


    return <>
        {deleteDeckRequested && <DialogComponent
            title={t('deleteDeckText1') + ` «${deck.name}» ` + t('deleteDeckText2')}
            onConfirm={deleteDeck}
            onClose={() => {
                setDeletDeckRequested(false)
            }}
        />}
        {fetched && <>
            <div className={cabinetStyle.header}/>
            <div className={cabinetStyle.mainPageContainer}>
                <PageTips headerText={t('header')}>
                    <div className={Style.h5Heading}>{t('headerText1')}</div>
                    <ul>
                        <li className={Style.bodyBaseText}>{t('headerText2')}</li>
                        <li className={Style.bodyBaseText}>{t('headerText3')}</li>
                    </ul>
                    <div className={Style.bodyBaseText}><b>{t('headerText4')}</b></div>
                </PageTips>
                {!nameEdit && <div className={myCardStyle.deckName}>
                    <div className={myCardStyle.deckNameText}>{deck.name}</div>
                    <EditComponent toolTipText={t('editName')} openOnClick={() => {
                        setNameEdit(true)
                    }}/>
                    <DeleteComponent toolTipText={t('deleteDeck')} openOnClick={() => {
                        requestDeckDelete()
                    }}/>
                </div>}
                {nameEdit && <div className={myCardStyle.deckName}>
                    <input type="text" value={newName} className={myCardStyle.deckNameText} onChange={resolveNewName}/>

                    <CloseComponent actOnClick={skipNameEdit} toolTipText={t('cancelButton')}/>
                    <SaveComponent actOnClick={saveNewName} toolTipText={t('saveButton')}/>
                </div>}
                {!styleEdit && <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "55px",
                    width: "660px",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "20px",
                        fontWeight: "600"
                    }}>{t('cardStyle')}
                    </div>
                    <div style={{
                        backgroundImage: "url(" + deck.background.background_image_url + ")",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        height: deck.background.image_height / 3,
                        width: deck.background.image_width / 3,
                        paddingTop: deck.background.padding_top / 3,
                        paddingBottom: deck.background.padding_bottom / 3,
                        paddingLeft: deck.background.padding_left / 3,
                        paddingRight: deck.background.padding_right / 3,
                        borderRadius: "6px",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        border: "0.5px solid black"
                    }}/>
                    <div>
                        <EditComponent toolTipText={t('change')} openOnClick={() => {
                            setStyleEdit(true)
                        }}/>
                        <div className={cabinetStyle.controlsEdit}>
                            <VisibilityIcon
                                style={{cursor: "pointer"}}
                                onClick={() => {setCardPreviewModal(true)}}
                            />
                        </div>
                    </div>
                </div>
                }
                {styleEdit && <div style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr",
                    justifyItems: "center",
                    width: "660px",
                    rowGap: "12px",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    overflow: "scroll",
                }}>
                    {availableCardStyles.map((as) => {
                        return <div
                            key={as.id}
                            style={{
                                backgroundImage: "url(" + as.background_image_url + ")",
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                height: "280px",
                                width: (as.image_width * 280 / as.image_height) + "px",
                                borderRadius: "6px",
                                cursor: "pointer",
                                border: deck.background.background_image_url === as.background_image_url ? "2px solid blue" : "0.5px solid black"
                            }}
                            onClick={() => {
                                saveNewDeckId(as.id)
                                setStyleEdit(false)
                            }
                            }
                        />
                    })}
                    <div
                        style={{
                            height: "280px",
                            width: "140px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            border: "0.5px solid black",
                            backgroundColor: "white",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                        onClick={() => {
                            setAddBackgroundDialog(true)
                        }
                        }
                    >
                        <div style={{
                            backgroundImage: "url(" + addPlus + ")",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundAttachment: "local",
                            backgroundPosition: "center",
                            height: "50px",
                            width: "50px",
                        }}>

                        </div>
                    </div>

                </div>}
                <div>{
                    Object.entries(deck.cards).map(([item, card]) => {
                        return <MyCard key={item} cellNumber={item} card={card} updateCards={fetchDeck}/>
                    })}</div>
            </div>
            {addBackgroundDialog && styleEdit && <MyCardsDeckEditAddOwnBackground
                show={addBackgroundDialog}
                fetchAvailableStyles={fetchAvailableStyles}
                onClose={() => {setAddBackgroundDialog(false)}}
            />}
            {cardPreviewModal && <CardTextModalPreview
                modalOpened={cardPreviewModal}
                closeModal={() => setCardPreviewModal(false)}
                cellNumber={1}
                background={deck.background}
                card={deck.cards[1]}
                mentor_notes="Cum vērum tempus advēnerit, velum cadet — et quod olim latuit, in lūcem ēmerget, clārē atque apertē. Nihil potest manēre occultum in aeternum: tempus est ianua, et lūx vocat vērum nōmine suō. Sīlentia rumpentur, umbrae fugiunt, et rēs intimae, quās cor tantum sciēbat, ante oculōs mundī stābunt, nūdā veritāte."
            />}

        </>
        }
    </>
}